import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { genreBacklog, type LibraryBook } from '@/lib/insights'
import { bookListUrl } from '@/lib/utils'
import { InsightCard, InsightEmpty } from './InsightCard'

/** Per genre: read vs still waiting on the shelf */
export function GenreBacklogCard({ books }: { books: LibraryBook[] }) {
  const { t } = useTranslation()
  const backlog = useMemo(() => genreBacklog(books, 6), [books])

  return (
    <InsightCard
      icon="📚"
      title={t('insights.backlog.title')}
      description={t('insights.backlog.description')}
    >
      {backlog.length === 0 ? (
        <InsightEmpty>{t('insights.backlog.empty')}</InsightEmpty>
      ) : (
        <ul className="space-y-3">
          {backlog.map(({ genre, owned, read, unread }) => (
            <li key={genre.id}>
              <Link
                to={bookListUrl({ status: 'unread', genre: genre.id })}
                className="block rounded-md p-1 -m-1 hover:bg-accent"
              >
                <div className="mb-1 flex justify-between gap-2 text-sm">
                  <span className="truncate font-medium text-foreground">{genre.name}</span>
                  <span className="shrink-0 text-xs text-muted-foreground">
                    {t('insights.backlog.unreadOfOwned', { unread, owned })}
                  </span>
                </div>
                <div className="flex h-2 w-full overflow-hidden rounded-full bg-muted">
                  <div
                    className="h-full"
                    style={{ width: `${(read / owned) * 100}%`, backgroundColor: genre.color }}
                  />
                </div>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </InsightCard>
  )
}
